import React, { Component, ReactNode } from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import contentTagsActions from '../../actions/contentTagsActions';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Button,
  Collapse,
  MenuItem,
  ListItemText,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from "react-select";
import { MyPATTextField, MyPATExpansionPanel, MyPATSelect } from '../../../common';

import ContentTagData, { CreateContentContentTagData } from '../../types/ContentTagData';
import moment from 'moment';
import value from '*.json';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import Autocomplete from '../../../common/Autocomplete';
import { Label } from '@material-ui/icons';
import AddFeedback from '../../../content-request/components/AddFeedback';
import { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import { SECTIONS } from '../../helper/contentValidation';
import AddFeedbackPopup from './AddFeedbackPopup';


const styles = (theme: Theme) => createStyles({
  blueColor: {
		color: '#1D7DEA'
	},
  feedbackContainer: {
		position: 'relative',
		'& .feedbackBlock': {
		  top: -16,
		  left: "100%",
		  position: "absolute",
		  marginLeft: 20,
		  zIndex: 2
		},
    '& span': {
      marginLeft: '5px',
    },
	  },
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardHeading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  requiredHeading: {
    color: theme.palette.secondary.main,
  },
  borderBox: {
    // border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing.unit * 2,
    backgroundColor: '#fff',
    "& .MuiFormHelperText-root-649":{
      display: 'none',
    },
  },
  reactSelectWrapper:{
    position: 'relative',
    "& svg":{
      display: 'none',
    },
    "& >div:nth-of-type(1) > div:nth-of-type(1)":{
      paddingLeft: 35,
      opacity: 0.6
    },
    "& img":{
      position: 'absolute',
      left: '10px',
      top: '39px',
      opacity: 0.6
    },
    // "& .css-1hb7zxy-IndicatorsContainer":{
    //   display: 'none',
    // },
    "& .css-2b097c-container":{
      marginTop: '3px',
    },
    "& .css-yk16xz-control":{
      border: '1px solid #dfdfdf',
    },
  },
  error:{
    color: '#f32b2b',
  },
  customLabel:{
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '19px',
    marginBottom: '10px',
    textTransform: 'capitalize'
  },
  customSelectEdit:{
    "& label":{
      fontSize: 22,
      fontWeight: 400,
      lineHeight: '19px',
      display: 'block',
      marginBottom: '-15px',
      position: 'initial',
    },
  },
  feedbackHighlight:{
    cursor: 'pointer',
    '&:hover':{
      color: '#1d7dea',
    }
  },
  optionalText: {
    fontSize: '20px',
    color: '#999999',
  }
});
interface AddExtraTagsProps extends WithStyles<typeof styles> {
  classes: any,
  isRequired: boolean,
  tagsList: {
    list: any,
    error: string | null,
  },
  contentTagsList: (contentType:any) => void,
  customHeading: ReactNode,
  defaultExpanded: boolean,
  handleFormChange: (tagsFormData: CreateContentContentTagData[]) => void,
  formData: CreateContentContentTagData[],
  error: boolean,
  errorText: string,
  contentType: string,
  isDisable: boolean,
  tag: string,
  openFeedback: boolean,
  addFeedback: Function,
  replyFeedback: Function,
  closeFeedback: Function,
  resolveFeedback: Function,
  clickedfeedbackData: any,
  addNewFeedback: Function,
  authorType?: string,
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
};

interface AddExtraTagsState {
  isShowMoreOpen: boolean,
  inputValue: string,
  selectedOption: any,
  selectedTag: string,

}

class AddExtraTags extends Component<AddExtraTagsProps, AddExtraTagsState>{

  constructor(props: AddExtraTagsProps) {
    super(props);
    this.state = {
      isShowMoreOpen: false,
      inputValue: '',
      selectedOption: null,
      selectedTag: '',
    };

    this.handlShowMoreClick = this.handlShowMoreClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    let {contentType} = this.props;
    if (_.isEmpty(this.props.tagsList.list)) {
      this.props.contentTagsList(contentType);
    }
  }

  handlShowMoreClick = () => this.setState({ isShowMoreOpen: !this.state.isShowMoreOpen });
  

  generateFormData = (name: string, value: any) => {
    const { tagsList, formData } = this.props;
    const formDataCopy = JSON.parse(JSON.stringify(formData));
    const tagData: any = _.find(tagsList.list, ['name', name]);
    const fieldToUpdate: any = _.find(formDataCopy, ['relation.name', name]);
    if(value[0] === 'Select') {
      value.splice(0, 1)
    }
    const inputData: any = {
      type: tagData.content.type,
      relation: {
        name,
        id: tagData._id,
      },
      values: tagData.content.type === 'listpickerMultiselect' || tagData.content.type === 'checkboxOptions' ? value : [value]
    };
    if(fieldToUpdate) {
      if(fieldToUpdate.type === 'listpickerMultiselect' || fieldToUpdate.type === 'checkboxOptions') {
        delete fieldToUpdate.values
      }
    }
    _.isUndefined(fieldToUpdate) ? formDataCopy.push(inputData) : _.merge(fieldToUpdate, inputData);
    // Unwanted multi concept field was getting added so removed it to solve CMV4-3423
    if (formDataCopy.length === 6 && formDataCopy[4].values && formDataCopy[4].values && formDataCopy[4].values.length &&
      (formDataCopy[4].values[0] === 'Multi Concept' || formDataCopy[4].values[0] === 'Single Concept' || formDataCopy[4].values[0] === 'Multi Subject') && formDataCopy[4].relation.name === 'Concept Categorizationn') {
      formDataCopy.splice(4, 1)
    }
    return formDataCopy;
  };

  handleInputChange(evt: any) {
    const { name, value } = evt.target;
    const formData: any = this.generateFormData(name, value);
    const finalFormData = formData.filter((tag: any)=> tag !== null)
    this.props.handleFormChange(finalFormData);
    localStorage.setItem('isConceptTagChanged', 'true');
  }

  onInputChange = (inputValue: any, actionData: any ) => {
    if (actionData.action === "menu-close") return;
    this.setState({ inputValue },
      () => {
        if (this.state.inputValue === '' && actionData.action === "input-change") {
          this.handleInputChange({ target: {name: this.state.selectedTag, value: ''} })
          this.setState({
            selectedOption: null
          })
        }
      });
}

  handleSelectChange = (selectedOption: any, tagData: any) => {
    this.setState({ selectedOption: selectedOption, selectedTag: tagData.name });
    this.handleInputChange({ target: {name:tagData.name, value: selectedOption.value} })
  };
  handleFocus = (tagData: any, fieldData: any) => {
    const { selectedOption } = this.state;
    if (selectedOption && selectedOption.label && this.state.selectedTag === tagData.name ) {
      this.setState({ inputValue: selectedOption.label, selectedTag: tagData.name });
    }
     else if(fieldData && this.state.selectedTag !== tagData.name) {
      this.setState({ inputValue: fieldData && fieldData.values && fieldData.values[0], 
        selectedTag: fieldData && fieldData.relation && fieldData.relation.name});
          } 
    else{
      this.setState({ inputValue: '', 
        selectedTag: tagData.name});
    }
  };

  removeItemFromArray(arr: any, attr: any, value: any) {
    let arrLength = arr.length;
    while (arrLength--) {
      if (arr[arrLength] && arr[arrLength].hasOwnProperty(attr) && (arguments.length > 2 && arr[arrLength][attr] === value)) {
        arr.splice(arrLength, 1);
      }
    }
    return arr;
  }

  render() {
    //remove course and question
    const { classes, isRequired, tagsList, customHeading, defaultExpanded, formData, error, errorText,contentType, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback } = this.props;
    const { isShowMoreOpen } = this.state;
    let requiredTagsList = _.filter(tagsList.list, ['isCompulsory', true]);
    let extraTagsList = _.filter(tagsList.list, ['isCompulsory', false]);
    extraTagsList = this.removeItemFromArray(extraTagsList, 'name', 'Course');
    extraTagsList = this.removeItemFromArray(extraTagsList, 'name', 'Question');

    // requiredTagsList = _.filter(requiredTagsList, (list:any) => !_.isEqual(list._id, '5da45cff18de535cef89af3b'));
    
    const getFieldForTag = (tagData: any, tagType: string, isRequired: boolean = false) => {
      const fieldData: any = _.find(formData, ['relation.name', tagData.name])

      if (_.isEqual(tagType, 'listpicker')) {
        return (
          <>
          <Grid className={classes.customSelectEdit}>
          <MyPATSelect
            label={tagData.name}
            inputId={tagData.name}
            name={tagData.name}
            // helperText={tagData.desc}
            value={_.isUndefined(fieldData) ? '' : fieldData.values[0]}
            onChange={this.handleInputChange.bind(this)}
            required={isRequired}
            fullWidthControl
          >
            <option value="">Select</option>
            {
              _.map(tagData.content.data, (data, index) =>
                <option key={index} value={data}>{data}</option>
              )
            }
          </MyPATSelect>
          </Grid>
          </>
        );
      }

      if (_.isEqual(tagType, 'listpickerMultiselect')) {
        return (
          <MyPATSelect
            label={tagData.name}
            inputId={tagData.name}
            name={tagData.name}
            value={_.isUndefined(fieldData) ? ['Select'] : fieldData.values.length > 0 ? fieldData.values : ['Select'] }
            multiple={true}
            isNative={false}
            onChange={this.handleInputChange.bind(this)}
            required={isRequired}
            fullWidthControl
          >
              {
                _.map(tagData.content.data, (data, index) => (
                  <MenuItem key={index} value={data}>
                  {/* {data} */}
                  <Checkbox
                    color="primary"
                    checked={(fieldData && fieldData.values || []).includes(data.toString())}
                  />
                  <ListItemText primary={data} />
                </MenuItem>
                ))
              }
          </MyPATSelect>
        );
      }

      if (_.isEqual(tagType, 'checkboxOptions')) {
        return (
          <MyPATSelect
            label={tagData.name}
            inputId={tagData.name}
            name={tagData.name}
            helperText={tagData.desc}
            value={_.isUndefined(fieldData) ? ['Select'] : fieldData.values.length > 0 ? fieldData.values : ['Select']}
            multiple={true}
            isNative={false}
            onChange={this.handleInputChange.bind(this)}
            required={isRequired}
            fullWidthControl
          >
            {
              _.map(tagData.content.data, (data, index) => (
                <MenuItem key={index} value={data}>
                  <Checkbox checked={fieldData && fieldData.values.indexOf(data) > -1} />
                  <ListItemText primary={data} />
                </MenuItem>
              ))
            }
          </MyPATSelect>
        );
      }

      /** @TODO Remove Radio Button Functionality

      if (_.isEqual(tagType, 'radioOptions')) {
        return (
          <RadioGroup name={tagData.name} value={_.isUndefined(fieldData) ? '' : fieldData.values[0]} onChange={this.handleInputChange.bind(this)}>
            {
               _.map(tagData.content.data, (data, index) => (
                <FormControlLabel value={data} control={<Radio />} label={data} />
              ))
            }
          </RadioGroup>
        );
      }

      */

      if (_.isEqual(tagType, 'radioOptions')) {
        return (
          <>
          <Grid className={classes.customSelectEdit}>
            <MyPATSelect
            label={tagData.name}
            inputId={tagData.name}
            name={tagData.name}
            helperText={tagData.desc}
            value={_.isUndefined(fieldData) ? '' : fieldData.values[0]}
            onChange={this.handleInputChange.bind(this)}
            required={isRequired}
            fullWidthControl
            className={classes.customSelectEdit}
            >
            <option value="">Select</option>
            {
              _.map(tagData.content.data, (data, index) =>
                <option key={index} value={data}>{data}</option>
              )
            }
          </MyPATSelect>
          </Grid>
          </>
        );
      }

      if (_.isEqual(tagType, 'datepicker')) {
        return (
          <MyPATTextField
            type="date"
            label={tagData.name}
            inputId={tagData.name}
            name={tagData.name}
            helperText={tagData.desc}
            value={_.isUndefined(fieldData) ? '' : fieldData.values[0]}
            onChange={this.handleInputChange.bind(this)}
            required={isRequired}
            inputProps={{
              min:moment().format('DD-MM-YYYY')
            }}
            fullWidthControl />
        )
      }

      if (_.isEqual(tagType, 'searchDropdown')) {
        return (
          <SectionFocusedContext.Consumer>
            {({ setSectionFocus }: SectionFocusedContextValue) => (
              <Grid className={classes.reactSelectWrapper}>
              <Typography className={classes.customLabel}>{tagData.name}<span className={classes.error}>*</span></Typography>
                <Select
                inputValue={this.state.selectedTag === tagData.name && this.state.inputValue ? this.state.inputValue : ''}
                defaultValue={fieldData && fieldData.values && fieldData.values[0] ? fieldData && fieldData.values && fieldData.values[0]: null}
                components={{IndicatorsContainer:() => null }}
                value={(fieldData && fieldData.values && fieldData.values[0] && {label:fieldData.values[0], value:fieldData.values[0]}) ? (fieldData && fieldData.values && {label:fieldData.values[0], value:fieldData.values[0]}) : null}
                onChange={(value: any) => this.handleSelectChange(value, tagData)}
                options={tagData.content.data.map((item: any) => ({label:item, value:item}))}
                placeholder={`Search ${tagData.name} here`}
                className={classes.customReactSelect}
                onFocus={() => {
                  this.handleFocus(tagData, fieldData);
                  setSectionFocus(true)
                }}
                onBlur={() => {
                  setSectionFocus(false)
                }}
                onInputChange={this.onInputChange.bind(this)} //the function to handle our search input
                blurInputOnSelect={true}


              />
                <img src="/assets/svg/myLibrary/search-icon.svg" />
              </Grid>
            )}
        </SectionFocusedContext.Consumer>
        )
      }

      

      return (
        <>
        <Grid className={classes.customSelectEdit}>
        <MyPATTextField
          label={tagData.name}
          inputId={tagData.name}
          name={tagData.name}
          // helperText={tagData.desc}
          value={_.isUndefined(fieldData) ? '' : fieldData.values[0]}
          onChange={this.handleInputChange.bind(this)}
          required={isRequired}
          fieldAttributes={{
            maxLength:tagData.content.textLength
          }}
          fullWidthControl />
          </Grid>
        </>
      );
    };

    return (
      <MyPATExpansionPanel
        hasExpandIcon
        defaultExpanded={defaultExpanded}
        variant="white"
        sectionId="addTags" // used for scrolling to this section
        customCollapseTitle={
          !_.isEmpty(customHeading) ? customHeading : (
            <>
            
            <Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
              if(this.props.addFeedback){
                event.stopPropagation();
                this.props.addFeedback('tags')
              }   
              }}>
            <span
            id={this.props.openFeedback && this.props.tag === "tags" ? 'feedbackScroll' : ''}
            className={`${classes.feedbackContainer} ${this.props.openFeedback && this.props.tag === "tags" ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}> Add Extra Tags
              {isRequired && <span className={classes.requiredHeading}>*</span>}
              <span className={classes.optionalText}> (Optional)</span>
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Add Extra Tags"
                imageURL="/assets/svg/infoIcon/extraTags.svg"
                dialogPara="Add Additional Taggings for the question based on Concept Categorization, Skills and Bloom's Taxonomy"
                details="Click to know more"
                toolTipDirection="top" />
                     
                     {this.props.openFeedback && this.props.tag === "tags" && (
                   <Grid className="feedbackBlock">
                   <AddFeedback 
                   author={this.props.authorType}
                   replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
                   </Grid>)}
                    {
                      activeValidationFeedbackSection === SECTIONS.TAGS && (
                        <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                      )
                    }
                   </span>
            </Typography>
            </>
          )
        }
        isDisable={this.props.isDisable}
        error={error}
        errorText={errorText}
        showErrorOnTouch
      >
        <div>
          <Grid container spacing={16} className={classes.mb1x}>
            {
              requiredTagsList.map((item, index) => (
                <Grid item sm={6} key={`${item._id} ${index}`}>
                  {getFieldForTag(item, item.content.type, isRequired)}
                </Grid>
              ))
            }
          </Grid>

          <Button
            size="small" color="primary"
            className={classes.mb1x}
            onClick={this.handlShowMoreClick.bind(this)}
          >
            {isShowMoreOpen ? '- Show Less' : '+ Show More'}
          </Button>

          <Collapse in={isShowMoreOpen}>
            <Grid container spacing={16} className={classes.mb1x}>
              {
                extraTagsList.map((item, index) => (
                  <Grid item sm={6} key={`${item._id} ${index}`}>
                    {getFieldForTag(item, item.content.type)}
                  </Grid>
                ))
              }
            </Grid>
          </Collapse>

        </div>
      </MyPATExpansionPanel>
    );
  }
};

const mapStateToProps = (state: any) => ({
  tagsList: _.get(state, 'mylibraryData.contentTags', {}),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  contentTagsList: contentTagsActions.contentTagsList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddExtraTags));